import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../style/gibraltar.css';

// Importing images for Slovenia (1-47)
import slovenia1 from '../images/slovenia1.jpeg';
import slovenia2 from '../images/slovenia2.jpeg';
import slovenia3 from '../images/slovenia3.jpeg';
import slovenia4 from '../images/slovenia4.jpeg';
import slovenia5 from '../images/slovenia5.jpeg';
import slovenia6 from '../images/slovenia6.jpeg';
import slovenia7 from '../images/slovenia7.jpeg';
import slovenia8 from '../images/slovenia8.jpeg';
import slovenia9 from '../images/slovenia9.jpeg';
import slovenia10 from '../images/slovenia10.jpeg';
import slovenia11 from '../images/slovenia11.jpeg';
import slovenia12 from '../images/slovenia12.jpeg';
import slovenia13 from '../images/slovenia13.jpeg';
import slovenia14 from '../images/slovenia14.jpeg';
import slovenia15 from '../images/slovenia15.jpeg';
import slovenia16 from '../images/slovenia16.jpeg';
import slovenia17 from '../images/slovenia17.jpeg';
import slovenia18 from '../images/slovenia18.jpeg';
import slovenia19 from '../images/slovenia19.jpeg';
import slovenia20 from '../images/slovenia20.jpeg';
import slovenia21 from '../images/slovenia21.jpeg';
import slovenia22 from '../images/slovenia22.jpeg';
import slovenia23 from '../images/slovenia23.jpeg';
import slovenia24 from '../images/slovenia24.jpeg';
import slovenia25 from '../images/slovenia25.jpeg';
import slovenia26 from '../images/slovenia26.jpeg';
import slovenia27 from '../images/slovenia27.jpeg';
import slovenia28 from '../images/slovenia28.jpeg';
import slovenia29 from '../images/slovenia29.jpeg';
import slovenia30 from '../images/slovenia30.jpeg';
import slovenia31 from '../images/slovenia31.jpeg';
import slovenia32 from '../images/slovenia32.jpeg';
import slovenia33 from '../images/slovenia33.jpeg';
import slovenia34 from '../images/slovenia34.jpeg';
import slovenia35 from '../images/slovenia35.jpeg';
import slovenia36 from '../images/slovenia36.jpeg';
import slovenia37 from '../images/slovenia37.jpeg';
import slovenia38 from '../images/slovenia38.jpeg';
import slovenia39 from '../images/slovenia39.jpeg';
import slovenia40 from '../images/slovenia40.jpeg';
import slovenia41 from '../images/slovenia41.jpeg';
import slovenia42 from '../images/slovenia42.jpeg';
import slovenia43 from '../images/slovenia43.jpeg';
import slovenia44 from '../images/slovenia44.jpeg';
import slovenia45 from '../images/slovenia45.jpeg';
import slovenia46 from '../images/slovenia46.jpeg';
import slovenia47 from '../images/slovenia47.jpeg';

function Slovenia() {
  const navigate = useNavigate();
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);

  // Array of all imported images
  const photos = [
    slovenia1, slovenia2, slovenia3, slovenia4, slovenia5, slovenia6, slovenia7, slovenia8, slovenia9, slovenia10,
    slovenia11, slovenia12, slovenia13, slovenia14, slovenia15, slovenia16, slovenia17, slovenia18, slovenia19, slovenia20,
    slovenia21, slovenia22, slovenia23, slovenia24, slovenia25, slovenia26, slovenia27, slovenia28, slovenia29, slovenia30,
    slovenia31, slovenia32, slovenia33, slovenia34, slovenia35, slovenia36, slovenia37, slovenia38, slovenia39, slovenia40,
    slovenia41, slovenia42, slovenia43, slovenia44, slovenia45, slovenia46, slovenia47
  ];

  // Function to handle image click
  const handleImageClick = (index) => {
    setSelectedImageIndex(index);
  };

  // Function to close the modal
  const closeModal = () => {
    setSelectedImageIndex(null);
  };

  // Function to navigate to the previous image
  const goToPrevious = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex === 0 ? photos.length - 1 : prevIndex - 1
    );
  };

  // Function to navigate to the next image
  const goToNext = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex === photos.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <div className="gibraltar-page">
      <h1>🇸🇮 Slovenia 2019 🇸🇮</h1>
      <button className="back-button" onClick={() => navigate(-1)}>
        &larr; 
      </button>

      <div className="photo-grid">
        {photos.map((photo, index) => (
          <div
            key={index}
            className="photo-item"
            onClick={() => handleImageClick(index)}
          >
            <img src={photo} alt={`Slovenia ${index + 1}`} />
          </div>
        ))}
      </div>

      {/* Modal for displaying the larger image */}
      {selectedImageIndex !== null && (
        <div className="modal" onClick={closeModal}>
          <div className="modal-content">
            <button className="arrow left-arrow" onClick={(e) => { e.stopPropagation(); goToPrevious(); }}>
              &larr;
            </button>
            <img
              src={photos[selectedImageIndex]}
              alt="Selected"
              className="modal-image"
            />
            <button className="arrow right-arrow" onClick={(e) => { e.stopPropagation(); goToNext(); }}>
              &rarr;
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Slovenia;